exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-row[data-v-456da7c2] {\n  margin-bottom: 10px;\n}\n.el-row .frm-tips[data-v-456da7c2] {\n    color: #8d8d8d;\n}\n.demo-table-expand[data-v-456da7c2] {\n  font-size: 0;\n}\n.demo-table-expand label[data-v-456da7c2] {\n  width: 90px;\n  color: #99a9bf;\n}\n.demo-table-expand .el-form-item[data-v-456da7c2] {\n  margin-right: 0;\n  margin-bottom: 0;\n  width: 50%;\n}\n.wxa-select[data-v-456da7c2] {\n  padding: 0 25px 25px;\n}\n.webchat-box[data-v-456da7c2] {\n  padding: 10px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-456da7c2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/workwx/authorize/index.vue
// module id = 1425
// module chunks = 0